import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import errorSvg from './error.svg?url';

import { Typography } from '@/components/ui/typography/typography.component';
import { Button } from '@/components/ui/button/button.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Card } from '@/components/ui/card.component';
import { config } from '@/config/config';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export interface ErrorStateProps {
  onReset?: () => void;
  description?: string;
}

const DEFAULT_MESSAGE
  = 'Não conseguimos carregar as informações. Verifique sua conexão ou tente novamente clicando no botão abaixo:';

export default function ErrorState({ description = DEFAULT_MESSAGE, onReset }: ErrorStateProps) {
  return (
    <div className="w-full bg-color-grey-100 flex items-center justify-center sm:my-10 px-100">
      <ContentContainer className="md:mt-6 sm:my-10 px-0">
        <Card className="max-w-xl mx-auto border-none rounded-2xl sm:shadow-floating py-6 flex flex-col items-center gap-6">
          <Image
            src={errorSvg}
            alt="Error"
            width={200}
            height={200}
            className="ml-10"
            priority
            data-testid={DataTestIdEnum.ERROR_STATE_IMAGE}
          />
          <div className="space-y-4 text-center">
            <Typography variant={TypographyVariant.TITLE} className="text-3xl sm:text-3xl" data-testid={DataTestIdEnum.ERROR_STATE_TITLE}>
              Algo deu errado!
            </Typography>
            <Typography data-testid={DataTestIdEnum.ERROR_STATE_DESCRIPTION}>{description}</Typography>
          </div>
          <div className="space-y-4 w-80">
            {onReset && (
              <Button onClick={onReset} data-testid={DataTestIdEnum.ERROR_STATE_TRY_AGAIN}>
                Tentar novamente
              </Button>
            )}
            <Button variant="secondary" asChild>
              <a href={`${config.env.baseUrl}/`} data-testid={DataTestIdEnum.ERROR_STATE_LINK_HOME_PAGE}>
                Página inicial
              </a>
            </Button>
          </div>
        </Card>
      </ContentContainer>
    </div>
  );
}
